import { SUPPORTED_NETWORK } from '../constants'

type AccessMethod = 'CODE' | 'WALLET' | 'NONE'
interface AccessMethodState {
  method: AccessMethod
  value: string
  linkWalletAddress?: string
}

const ACCESS_METHOD_STORAGE_KEY = `@${SUPPORTED_NETWORK.OPTIMEX}-access-method`

const DEFAULT_METHOD_STATE: AccessMethodState = {
  method: 'NONE',
  value: '',
}

export const accessMethodStorage = {
  getState: (): AccessMethodState => {
    try {
      const stored = localStorage.getItem(ACCESS_METHOD_STORAGE_KEY)
      if (!stored) return DEFAULT_METHOD_STATE
      return JSON.parse(stored) as AccessMethodState
    } catch (error) {
      console.error('Error getting access method state:', error)
      return DEFAULT_METHOD_STATE
    }
  },

  save: (state: AccessMethodState) => {
    localStorage.setItem(ACCESS_METHOD_STORAGE_KEY, JSON.stringify(state))
  },

  update: (payload: Partial<AccessMethodState>) => {
    try {
      const currentState = accessMethodStorage.getState()
      accessMethodStorage.save({
        ...currentState,
        ...payload,
      })
    } catch (error) {
      console.error('Error updating access method:', error)
    }
  },

  remove: () => {
    localStorage.removeItem(ACCESS_METHOD_STORAGE_KEY)
  },
}
